import { createRandomString } from "./createRandomString";

export const createAttributionId = () => {
  return createRandomString(8);
};
